import Vue from 'vue'
import VueLeaflet from '@vdcrea/vue-leaflet'
Vue.use(VueLeaflet)
